import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import color from "../../../Constants/colors";
import { ComoButton } from "../../Common/ComoButton";

interface Props {
  open: boolean;
  title: string;
  text: string;
  confirmLabel: string;
  pending: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const VoicesConfirmDialog: React.FC<Props> = ({
  open,
  title,
  text,
  confirmLabel,
  pending,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation("voicesCommon");

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ color: color.gray900, fontWeight: 600 }}>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ color: color.gray700 }}>
          {text}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ color: color.gray600, textTransform: "none" }}>
          {t("cancel")}
        </Button>
        <ComoButton onClick={onConfirm} disabled={pending}>
          {confirmLabel}
        </ComoButton>
      </DialogActions>
    </Dialog>
  );
};

export default VoicesConfirmDialog;
